var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboardInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 2C7.33333 1.44772 7.78105 1 8.33333 1H15.6667C16.219 1 16.6667 1.44772 16.6667 2C16.6667 2.55228 16.219 3 15.6667 3H8.33333C7.78105 3 7.33333 2.55228 7.33333 2ZM9.33333 7.37755V21.4286H14.6667V7.37755H9.33333ZM16.6667 14.8622V7.25306C16.6667 6.8073 16.5199 6.35169 16.2185 5.99187C15.9127 5.6268 15.456 5.37755 14.9333 5.37755H9.06667C8.54399 5.37755 8.08729 5.6268 7.78151 5.99187C7.48012 6.3517 7.33333 6.8073 7.33333 7.25306V11.9439H1.73333C1.21066 11.9439 0.753956 12.1931 0.448181 12.5582C0.146787 12.918 0 13.3736 0 13.8194V21.5531C0 21.9988 0.146787 22.4544 0.448181 22.8143C0.753956 23.1793 1.21066 23.4286 1.73333 23.4286H22.2667C22.7893 23.4286 23.246 23.1793 23.5518 22.8143C23.8532 22.4544 24 21.9988 24 21.5531V16.7378C24 16.292 23.8532 15.8364 23.5518 15.4766C23.246 15.1115 22.7893 14.8622 22.2667 14.8622H16.6667ZM16.6667 16.8622V21.4286H22V16.8622H16.6667ZM7.33333 13.9439H2V21.4286H7.33333V13.9439Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardInactive);
export default __webpack_public_path__ + "static/media/leaderboard_inactive.7e5af9c02f03e8785defb13e3835c543.svg";
export { ForwardRef as ReactComponent };